"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = ['subStart', 'subEnd', 'videoQuantity', 'amendmentsQuantity', 'slaTurnaround', 'storageAllowance', 'resetPeriod'];
exports.default = _default;